var _ = require('lodash');
var AppConstants = require('../constants/ApplicationConstants');
var Constants = require('../constants/FundingYourProductConstants');
var Formatter = require('./Formatter.js');
var Products = require('./Products.js');
var RollOverTypes = Constants.RollOverTypes;
var HowMuchToRollOver = Constants.HowMuchToRollOver;

module.exports = {
    checkIfApplicantIsEligibleForInternalTransfers: function(clientOin, accountType) {
        if (window.NOA.userContext.isExisting) {
            if (!clientOin && window.NOA.userContext.userType === AppConstants.UserTypes.ADVISER) {
                return false;
            } else {
                if (accountType === AppConstants.AccountTypeCodes.INDIVIDUAL) {
                    return true;
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
    },
    checkIfApplicantIsEligibleForInternalRollovers: function(clientOin) {
        if (window.NOA.userContext.isExisting) {
            if (!clientOin &&
                window.NOA.userContext.userType === AppConstants.UserTypes.ADVISER) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    },

    convertInternalRolloversToExternalRollovers: function(summaryData) {
        if (summaryData.length > 0) {
            var newList = _.cloneDeep(summaryData);
            for (var i = 0; i < newList.length; i++) {
                if (newList[i].rollOverType === RollOverTypes.INTERNAL) {
                    newList[i].rollOverType = RollOverTypes.EXTERNAL;
                    newList[i].selectedManualEntryProductId = '';
                }
            }
            return newList;
        }
        return summaryData;
    },
    performInternalRolloverConversionIfRequired: function(clientOin, productId, summaryData, accountType) {
        if (Products.isAnnuity(productId)) {
            return [];
        } else if (Products.isInvestment(productId) &&
            !this.checkIfApplicantIsEligibleForInternalTransfers(clientOin, accountType)) {
            return [];
        } else if (!this.checkIfApplicantIsEligibleForInternalRollovers(clientOin)) {
            return this.convertInternalRolloversToExternalRollovers(summaryData);
        } else {
            return summaryData;
        }
    },
    determineBalanceAndAmount: function(dataToSubmit) {
        let newBalance;
        let newAmount;
        const amtBal = parseFloat(Formatter.removeCommas(dataToSubmit.remainingBalance));
        const numBal = new Number(amtBal);
        const amt = parseFloat(Formatter.removeCommas(dataToSubmit.rollOverAmount));
        const num = new Number(amt);
        switch (dataToSubmit.partialRolloverType) {
        case Constants.HowMuchToRollOver.LEAVE_AMOUNT:
            newAmount = numBal - num;
            newBalance = num;
            dataToSubmit.isPartialRollOver = true;
            break;
        case Constants.HowMuchToRollOver.ENTER_AMOUNT:
            newAmount = num;
            newBalance = numBal - num;
            dataToSubmit.isPartialRollOver = true;
            break;
        default:
            newAmount = numBal;
            newBalance = 0;
            dataToSubmit.isPartialRollOver = false;
            break;
        }

        dataToSubmit.rollOverAmount = Formatter.currencyFormat(newAmount.toString());
        dataToSubmit.remainingBalance = Formatter.currencyFormat(newBalance.toString());
        return dataToSubmit;
    },
    createExistingAccount: function (data, intAccountCount) {
        if (data && data.isExistingAccount) {
            var result = {
                id: data.productId,
                internalAccountIndex: intAccountCount,
                accountNumber: data.accountNumber,
                hideInvestments: true,
                accountName: data.rollOverName
            };
            result.investmentOptions = _.cloneDeep(data.investmentOptions);
            if (data.partialRolloverType === HowMuchToRollOver.ENTIRE_BALANCE) {
                result.accountBalance = data.rollOverAmount;
            } else {
                result.accountBalance = data.rollOverAmount + data.remainingBalance;
            }
            return result;
        }
        return null;
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./utils/FundingYourProductHelperPart2.js